/** Count each address/token pair once when balances overlap across contexts. */
export const uniqueBalanceAccounts = <
  T extends {
    readonly address: string;
    readonly asset: { readonly asset: string };
  },
>(
  accounts: readonly T[]
): T[] => {
  const unique = new Map<string, T>();
  for (const account of accounts) {
    const key = JSON.stringify([account.address, account.asset.asset]);
    if (!unique.has(key)) unique.set(key, account);
  }
  return [...unique.values()];
};
